module.exports = __webpack_public_path__ + "static/media/chuveiro.8ad81206.svg";